import { useEffect, useMemo } from 'react'

export const usePagination = (
    boundaryCount: number,
    currentPage: number,
    onPageChange: (currentPage: number) => void,
    pageCount: number,
    siblingCount: number
): (number | 'break')[] => {
    useEffect(() => {
        onPageChange(currentPage)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage])

    const pages = useMemo(
        () => Array.from(Array(pageCount), (_e, i) => i + 1),
        [pageCount]
    )

    const updatedPages = useMemo(
        () =>
            pages.map((page) => {
                // Number is same as currentStep
                const isCurrentStep = page === currentPage

                // Number is in sibling range
                const isSibling =
                    currentPage - siblingCount <= page &&
                    currentPage + siblingCount >= page

                const firstMargin = boundaryCount
                const lastMargin = pages.length + 1 - boundaryCount

                // Number is in boundary range (outer numbers)
                const isBoundary = page <= firstMargin || page >= lastMargin

                const siblingExtra = siblingCount * 2
                const boundaryStart = firstMargin + 1 + siblingExtra
                const boundaryEnd = lastMargin - 1 - siblingExtra

                // Number and currentStep is close to boundary range (show more numbers)
                const isCloseBoundary =
                    (currentPage < boundaryStart &&
                        page <= boundaryStart + 1) ||
                    (currentPage > boundaryEnd && page >= boundaryEnd - 1)

                return isCurrentStep ||
                    isSibling ||
                    isBoundary ||
                    isCloseBoundary
                    ? page
                    : 'break'
            }),
        [currentPage, boundaryCount, pages, siblingCount]
    )

    return updatedPages
}
